<app-crud-edit
  [sectionTitle]="sectionTitle"
  [buttonTitle]="buttonTitle"
  [entityroot]="entityrooturl"
  [onSubmit]="onSubmitHandler()"
  [onCancel]="onCancelHandler()"
  [form]="form"
  [fields]="fields"
  [options]="options"
  [model]="model"
  [isReady]="isReady"
  [isSubmitting]="isSubmitting"
></app-crud-edit>

<ng-template #confirmtemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Tool removed</h4>
    <button type="button" class="close pull-right" User edit aria-label="Close" (click)="closeConfirmRemoveDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="text-start">You removed a tool from this user. If you save your changes all configured markets for this tool will be deleted.<br/>Click the cancel button if you want to discard your changes.</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeConfirmRemoveDialog()">Ok</button>
  </div>
</ng-template>
